// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"8449350b","431":"abb2cb36","488":"a579d194","664":"f77b28d2","795":"3a4a6b0b"}[chunkId] + ".chunk.js";
};